import * as React from 'react';
import { useRouterContent } from '../hooks/useRouterContent';
export function RouterContent() {
    return React.createElement(React.Fragment, null, useRouterContent());
}
